const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getTestOrderDetail({ rootState }, params = {}) {
      const data = await rootState.http("/check/getCheckOrder", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/check.js